import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ISwitchBusinessProfileRequest, ISwitchBusinessProfileResponse } from '../models/switch-to-another-business-profile.model';

export const loadSwitchToAnotherBusinessProfiles = createAction(
  '[SwitchToAnotherBusinessProfile] Load SwitchToAnotherBusinessProfiles',
  props<{ request: ISwitchBusinessProfileRequest }>()
);

export const loadSwitchToAnotherBusinessProfilesSuccess = createAction(
  '[SwitchToAnotherBusinessProfile] Load SwitchToAnotherBusinessProfiles Success',
  props<{ response: ISwitchBusinessProfileResponse }>()
);

export const loadSwitchToAnotherBusinessProfilesFailure = createAction(
  '[SwitchToAnotherBusinessProfile] Load SwitchToAnotherBusinessProfiles Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearLoadSwitchToAnotherBusinessProfiles = createAction(
  '[SwitchToAnotherBusinessProfile] Clear SwitchToAnotherBusinessProfiles Success'
);
